import { createContext, useContext } from "react";
import { AuthContext } from ".";
import { toast } from 'react-toastify';
import { conection } from '../utils/index'
import moment from "moment";


export const AuthContextApi = createContext();


const AuthProvider = ({ children }) => {

    const { states, setters } = useContext(AuthContext);
    const axiosAuth = conection.auth();
    const axiosNoAuth = conection.noAuth();


    const login = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.get('/user/login')
            const response = await axiosNoAuth.post('/user/login', data)
            localStorage.setItem('token', response.data.data.token)
            localStorage.setItem('permisssion', response.data.data.permissao)
            localStorage.setItem('cliente', response.data.data.client)
            localStorage.setItem('usuario', response.data.data.user)
            localStorage.setItem('proprietario', response.data.data.proprietario)
            setters.setSigned(true)
            setters.setIsLoading(false)
            toast.success(response.data.msg)
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const checkLogin = async () => {
        try {
            await axiosAuth.get('/user/check')
            return true;
        } catch (err) {
            console.log(err)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error(err.response.data.msg)
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const forgotPass = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.post('/user/forgotPassword', data)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }

    const forgotChangePass = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.post('/user/forgotChangePass', data)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }

    const logout = async () => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.get('/user/logOut')
            setters.setIsLoading(false)
            localStorage.removeItem('token')
            localStorage.removeItem('permisssion')
            localStorage.removeItem('cliente')
            localStorage.removeItem('usuario')
            setters.setSigned(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }


    //#region Recuperação de Senha

    const getRecuperacaoDeSenhaDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/recuperacaoSenha')
            setters.setIsLoading(false)
            setters.setDataEstatisticaRecuperacaoSenha(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRecuperacaoSenha = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/userForgot/getWithLimit/${states.limiteRecuperacaoSenha}&${states.offsetRecuperacaoSenha}`)
            setters.setIsLoading(false)
            setters.setDataRecuperacaoSenha(response.data.data)
            if (states.dataRecuperacaoSenha.length === 0) toast.success('Recuperações de senhas carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                setters.setLimiteBuscaRecuperacaoSenha(true)
                if (states.offsetRecuperacaoSenha > 0) {
                    setters.setOffsetRecuperacaoSenha(states.offsetRecuperacaoSenha - states.limiteRecuperacaoSenha)
                }
                if (states.offsetRecuperacaoSenha < 0) {
                    setters.setOffsetRecuperacaoSenha(0)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRecuperacaoSenhaQuery = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/userForgot/${query}/getWithLimit/${states.limiteRecuperacaoSenha}&${states.offsetRecuperacaoSenha}`)
            setters.setIsLoading(false)
            setters.setDataRecuperacaoSenha(response.data.data)
            if (states.dataRecuperacaoSenha.length === 0) toast.success('Recuperações de senhas carregados com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                setters.setLimiteBuscaRecuperacaoSenha(true)
                if (states.offsetRecuperacaoSenha > 0) {
                    setters.setOffsetRecuperacaoSenha(states.offsetRecuperacaoSenha - states.limiteRecuperacaoSenha)
                }
                if (states.offsetRecuperacaoSenha < 0) {
                    setters.setOffsetRecuperacaoSenha(0)
                }
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    //#endregion

    //#region Usuários

    const getUsuariosDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/usuarios')
            setters.setIsLoading(false)
            setters.setDataEstatisticaUsuarios(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getUsuarios = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/user?${query}`)
            setters.setIsLoading(false)
            setters.setDataUsuarios(response.data.data)
            if (states.dataUsuarios.length === 0) toast.success('Usuarios carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                setters.setLimiteBuscaUsuarios(true)
                if (states.offsetUsuarios > 0) {
                    setters.setOffsetUsuarios(states.offsetUsuarios - states.limiteUsuarios)
                }
                if (states.offsetUsuarios < 0) {
                    setters.setOffsetUsuarios(0)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    const getUsuariosQuery = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/user?${query}`)
            setters.setIsLoading(false)
            setters.setDataUsuarios(response.data.data)
            if (states.dataUsuarios.length === 0) toast.success('Usuarios carregados com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                setters.setLimiteBuscaUsuarios(true)
                if (states.offsetUsuarios > 0) {
                    setters.setOffsetUsuarios(states.offsetUsuarios - states.limiteUsuarios)
                }
                if (states.offsetUsuarios < 0) {
                    setters.setOffsetUsuarios(0)
                }
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const postUsuarios = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/user/create', data)
            setters.setIsLoading(false)
            toast.success('Usuário cadastrado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error(err.response.data.msg)
                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const putRoleUsuarios = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/role/${states.Usuarios.id}`, data)
            setters.setIsLoading(false)
            setters.setUsuarios({})
            toast.success('Usuário editado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const blockUnlockUsuarios = async (id, status) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/blockUnlock/${id}`, { noData: "data" })
            setters.setIsLoading(false)
            setters.setUsuarios({})
            const msg = status ? 'Usuário desbloqueado com sucesso' : 'Usuário bloqueado com sucesso'
            toast.success(msg)
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const deleteUsuarios = async (id, status) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.delete(`/user/${id}`)
            setters.setIsLoading(false)
            setters.setUsuarios({})
            toast.success('Usuário deletado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    //#endregion

    //#region Logs

    const getLogsDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/logs')
            setters.setIsLoading(false)
            setters.setDataEstatisticaLogs(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getLogsMetricas = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/logs/metricas')
            setters.setIsLoading(false)
            setters.setDataEstatisticaLogs(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRequestsMetricas = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/requests/metrics')
            setters.setIsLoading(false)
            setters.setDataEstatisticaRequests(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getLogs = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/logs?${query}`)
            setters.setIsLoading(false)
            setters.setDataLogs(response.data.data)
            if (response.data.data.length === 0) toast.success('Logs carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                // Reset para página anterior se houver erro
                if (states.page > 0) {
                    setters.setPage(states.page - 1)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    //#endregion

    //#region clientes 

    const getClientesByCpfCnpj = async (cpfCnpj) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/clientes/codigoRegistro/${cpfCnpj}`)
            setters.setIsLoading(false)
            setters.setClientes(response.data.data)
            if (states.dataFaturas.length === 0) toast.success('Faturas carregados com sucesso')
            return { status: true, data: response.data.data }
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return { status: false }
        }
    }

    const getClientesDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/clientes')
            setters.setIsLoading(false)
            setters.setDataEstatisticaClientes(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getClientes = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/clientes/getWithLimit/${states.limiteClientes}&${states.offsetClientes}`)
            setters.setIsLoading(false)
            setters.setDataClientes(response.data.data)
            if (states.dataClientes.length === 0) toast.success('Clientes carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                setters.setLimiteBuscaClientes(true)
                if (states.offsetClientes > 0) {
                    setters.setOffsetClientes(states.offsetClientes - states.limiteClientes)
                }
                if (states.offsetClientes < 0) {
                    setters.setOffsetClientes(0)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    const getClientesQuery = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/clientes/${query}/getWithLimit/${states.limiteClientes}&${states.offsetClientes}`)
            setters.setIsLoading(false)
            setters.setDataClientes(response.data.data)
            if (states.dataClientes.length === 0) toast.success('Clientes carregados com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                setters.setLimiteBuscaClientes(true)
                if (states.offsetClientes > 0) {
                    setters.setOffsetClientes(states.offsetClientes - states.limiteClientes)
                }
                if (states.offsetClientes < 0) {
                    setters.setOffsetClientes(0)
                }
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const postCliente = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/clientes', data)
            setters.setIsLoading(false)
            toast.success('Cliente cadastrado com sucesso')
            await getClientes()
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return false;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const putCliente = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/clientes/${states.Clientes.id}`, data)
            setters.setIsLoading(false)
            toast.success('Cliente cadastrado com sucesso')
            setters.setClientes({})
            await getClientes()
            return true;
        } catch (err) {
            setters.setClientes({})
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return false;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }


    const getClienteById = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/clientes/${id}`)
            setters.setClientes(response.data.data)
            setters.setIsLoading(false)
            toast.success('Cliente carregado com sucesso')
            return true;
        } catch (err) {
            setters.setClientes({})
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return false;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }


    const getClientePainelDataSistema = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/dadosSistema/cliente/${id}`)
            setters.setIsLoading(false)
            setters.setDataEstatisticaPainelCliente(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }


    //#endregion


    //#region dashBoard



    const getDashBoardataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/dadosSistema/dashBoard`)
            setters.setIsLoading(false)
            setters.setDataEstatisticaDashBoard(response.data.data)
            return response.data
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return { status: false };
            } else {
                toast.error(err.response.data.msg)
                return { status: false };
            }
        }
    }

    //#endregion

    //#region profile



    const profileChangeEmail = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post(`/user/changeemail`, data)
            setters.setIsLoading(false)
            const saveEmail = localStorage.getItem('userEmail')
            if (saveEmail) {
                localStorage.setItem('userEmail', data.email)
            }
            toast.success('Email alterado com sucesso. Confirme a alteração no seu e-mail atual')
            return { status: true };
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return { status: false }
            } else {
                toast.error(err.response.data.msg)
            }
            return { status: false };
        }
    }


    const profileChangeSenha = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post(`/user/changePassword`, data)
            const saveSenha = localStorage.getItem('userPassword')
            if (saveSenha) {
                localStorage.setItem('userPassword', data.novaSenha)
            }
            setters.setIsLoading(false)
            toast.success('Senha alterado com sucesso.')
            return true;
        } catch (err) {
            console.log(err)
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileChangeEmailConfirm = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/changeemail/${token}`)
            setters.setIsLoading(false)
            toast.success('Email alterado com sucesso.')
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileAutenticationEmail = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/authEmail/${token}`)
            setters.setIsLoading(false)
            toast.success('Email autenticado com sucesso.')
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileChangeEmailConfirmCheckLink = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.get(`/user/checkLink/${token}`)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            localStorage.removeItem('token')
            localStorage.removeItem('permisssion')
            localStorage.removeItem('cliente')
            localStorage.removeItem('usuario')
            setters.setSigned(false)
            toast.error(err.response.data.msg)

            return false;
        }
    }



    //#endregion

    //#region equipamento //Page, per_page, sort, sort_dir, filter


    const getEquipamentos = async (query) => {
        setters.setIsLoading(true)
        try {

            const response = await axiosAuth.get(`/equipamentos?${query}`)

            setters.setIsLoading(false)
            setters.setDataEquipamentos(response.data.data)
            return response.data.data;
        } catch (err) {
            console.error('getEquipamentos - Erro:', err)
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar equipamentos')
            }
            return false;
        }
    }

    const getEquipamentoHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/equipamentos/${id}?${query}`)
            setters.setIsLoading(false)
            if (states.equipamentoHistorico.length > 0) {
                setters.setEquipamentoHistorico(e => [...e, ...response.data.data])
            } else {
                setters.setEquipamentoHistorico(response.data.data)
            }
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao carregar histórico de equipamentos')
        }
    }

    const getEstatisticasEquipamentos = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/equipamento')
            setters.setIsLoading(false)
            setters.setDataEstatisticaEquipamentos(response.data.data)
            return true;
        } catch (err) {

            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar estatísticas de equipamentos')
            }
            return false;
        }
    }

    const postEquipamentos = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/equipamentos', data)
            setters.setIsLoading(false)
            toast.success('Equipamento cadastrado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }


    }

    const putEquipamentos = async (data) => {
        setters.setIsLoading(true)
        try {
            const { id, ...payload } = data
            const response = await axiosAuth.patch(`/equipamentos/${id}`, payload)
            setters.setIsLoading(false)
            toast.success('Equipamento atualizado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                const errorMsg = err.response?.data?.msg || err.message || 'Erro ao atualizar equipamento'

                toast.error(errorMsg)
            }
        }
        return false;
    }

    //#endregion

    //#region equipamentoFormato //Page, per_page, sort, sort_dir, filter


    const getEquipamentosformatos = async (query, equipamento_id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/equipamentoFormato/equipamento/${equipamento_id}?${query}`)
            setters.setIsLoading(false)
            setters.setDataEquipamentoFormato(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return false;
            } else {
                const errorMsg = err.response?.data?.msg || err.message || 'Erro ao carregar formatos'
                toast.error(errorMsg)
            }
            return false;
        }
    }

    const getEquipamentoFormatoHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/equipamentoFormato/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setEquipamentoFormatoHistorico(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao carregar histórico de formatos')
        }
    }

    const postEquipamentoFormato = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/equipamentoFormato', data,)
            setters.setIsLoading(false)
            toast.success('Formato cadastrado com sucesso')
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return false;
            } else {
                const errorMsg = err.response?.data?.msg || err.message || 'Erro ao cadastrar formato'

                toast.error(errorMsg)
            }
            return false;
        }
    }

    const putEquipamentoFormato = async (data) => {
        setters.setIsLoading(true)
        try {

            const { id, ...payload } = data

            await axiosAuth.patch(`/equipamentoFormato/${id}`, payload)
            setters.setIsLoading(false)
            toast.success('Formato atualizado com sucesso')
            return true;
        } catch (err) {




            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                const errorMsg = err.response?.data?.msg || err.message || 'Erro ao atualizar formato'

                toast.error(errorMsg)
            }
        }
        return false;
    }

    // //#endregion

    //#region entidade


    const getEntidades = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/entidade?${query}`)
            setters.setIsLoading(false)
            setters.setDataEntidades(response.data.data)
            return response.data.data;
        } catch (err) {

            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                const msg = err.response?.data?.msg || 'Erro ao carregar entidades'
                if (msg !== 'Nenhum registro encontrado!') {
                    toast.error(msg)
                }
            }
            return false;
        }
    }

    const getEntidade = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/entidade/data/${id}`)
            setters.setIsLoading(false)
            setters.setEntidade(response.data.data)
            return response.data.data;
        } catch (err) {

            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar entidades')
            }
            return false;
        }
    }

    const getEntidadeHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/entidade/${id}?${query}`)
            setters.setIsLoading(false)
            if (states.entidadeHistorico.length > 0) {
                setters.setEntidadeHistorico(e => [...e, ...response.data.data])
            } else {
                setters.setEntidadeHistorico(response.data.data)
            }
            return response.data.data;
        } catch (err) {

            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar entidades')
            }
            return false;
        }
    }

    const postEntidades = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/entidade', data)
            setters.setIsLoading(false)
            toast.success('Entidade criada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                const errorMsg = err.response?.data?.msg || err.message || 'Erro ao criar entidade'

                toast.error(errorMsg)
            }
        }
        return false;
    }

    const putEntidades = async (data) => {
        setters.setIsLoading(true)
        try {
            const { id, ...payload } = data
            const response = await axiosAuth.patch(`/entidade/${id}`, payload)
            setters.setIsLoading(false)
            toast.success('Entidade atualizada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                const errorMsg = err.response?.data?.msg || err.message || 'Erro ao atualizar entidade'
                console.error('putEntidades - Mensagem de erro:', errorMsg)
                toast.error(errorMsg)
            }
        }
        return false;
    }

    const deleteEntidades = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.delete(`/entidade/${id}`)
            setters.setIsLoading(false)
            toast.success('Entidade deletada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                const errorMsg = err.response?.data?.msg || err.message || 'Erro ao deletar entidade'
                toast.error(errorMsg)
            }
        }
        return false;
    }

    const getEstatisticasEntidades = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/entidade')
            setters.setIsLoading(false)
            setters.setDataEstatisticaEntidades(response.data.data)
            return true;
        } catch (err) {
            console.error('getEstatisticasEntidades - Erro:', err)
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar estatísticas de entidades')
            }
            return false;
        }
    }

    //#endregion

    //#region localizacao

    const getLocalizacoes = async (entidade_id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/localizacao/${entidade_id}?${query}`)
            setters.setIsLoading(false)
            setters.setDataLocalizacao(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar localizações')
            }
            return false;
        }
    }

    const getLocalizacoesProprietario = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/localizacao/proprietario?${query}`)
            setters.setIsLoading(false)
            setters.setDataLocalizacao(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar localizações proprietário')
            }
            return false;
        }
    }

    const getLocalizacaoHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/localizacao/historico/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setLocalizacaoHistorico(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar localizações')
            }
            return false;
        }
    }

    const postLocalizacoes = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/localizacao', data)
            setters.setIsLoading(false)
            toast.success('Localização cadastrada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao cadastrar localização')
            return false;
        }
    }

    const putLocalizacoes = async (data) => {
        setters.setIsLoading(true)
        try {
            const { id, ...payload } = data
            const response = await axiosAuth.patch(`/localizacao/${id}`, payload)
            setters.setIsLoading(false)
            toast.success('Localização atualizada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao atualizar localização')
            return false;
        }
    }

    const deleteLocalizacoes = async (id) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.delete(`/localizacao/${id}`)
            setters.setIsLoading(false)
            toast.success('Localização deletada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao deletar localização')
            return false;
        }
    }

    //#endregion

    //#region departamento

    const getDepartamentos = async (localizacao_id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/departamento/${localizacao_id}?${query}`)
            setters.setIsLoading(false)
            setters.setDataDepartamento(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao carregar departamentos')
            return false;
        }
    }

    const getDepartamentoHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/departamento/historico/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setDepartamentoHistorico(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao carregar departamentos')
            return false;
        }
    }

    const postDepartamentos = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/departamento', data)
            setters.setIsLoading(false)
            toast.success('Departamento cadastrado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao cadastrar departamento')
            return false;
        }
    }

    const putDepartamentos = async (data) => {
        setters.setIsLoading(true)
        try {
            const { id, ...payload } = data
            const response = await axiosAuth.patch(`/departamento/${id}`, payload)
            setters.setIsLoading(false)
            toast.success('Departamento atualizado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao atualizar departamento')
            return false;
        }
    }

    const deleteDepartamentos = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.delete(`/departamento/${id}`)
            setters.setIsLoading(false)
            toast.success('Departamento deletado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao deletar departamento')
            return false;
        }
    }


    //#endregion

    //#region marca

    const getMarcas = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/marca?${query}`)
            setters.setIsLoading(false)
            setters.setDataMarcas(response.data.data)
            return response.data.data;
        } catch (err) {

            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar marcas')
            }
            return false;
        }
    }

    const getMarcaHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/marca/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setMarcaHistorico(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao carregar histórico de marcas')
        }
    }


    const getEstatisticasMarcas = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/marca')
            setters.setIsLoading(false)
            setters.setDataEstatisticaMarcas(response.data.data)
            return true;
        } catch (err) {

            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar estatísticas de marcas')
            }
            return false;
        }
    }

    const postMarcas = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/marca', data)
            setters.setIsLoading(false)
            toast.success('Marca cadastrada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }


    }

    const putMarcas = async (data) => {
        setters.setIsLoading(true)
        try {
            const { id, ...payload } = data
            const response = await axiosAuth.patch(`/marca/${id}`, payload)
            setters.setIsLoading(false)
            toast.success('Marca atualizada com sucesso')
            return true;
        } catch (err) {

            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                const errorMsg = err.response?.data?.msg || err.message || 'Erro ao atualizar marca'
                console.error('putMarcas - Mensagem de erro:', errorMsg)
                toast.error(errorMsg)
            }
        }
        return false;
    }

    //#endregion

    //#region fornecedores

    const getFornecedores = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/fornecedor?${query}`)
            setters.setIsLoading(false)
            if (response.data.data.length > 0) {
                setters.setDataFornecedores(response.data.data)
            }
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao carregar fornecedores')
        }
    }

    const getFornecedoresHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/fornecedor/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setFornecedoresHistorico(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao carregar histórico de fornecedores')
        }

    }

    const getEstatisticasFornecedores = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/fornecedor')
            setters.setIsLoading(false)
            setters.setDataEstatisticaFornecedores(response.data.data)
            return true;

        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao carregar estatísticas de fornecedores')
        }
        return false;
    }

    const postFornecedores = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/fornecedor', data)
            setters.setIsLoading(false)
            toast.success('Fornecedor cadastrado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao cadastrar fornecedor')
        }
    }

    const putFornecedores = async (data) => {
        setters.setIsLoading(true)
        try {
            const { id, ...payload } = data
            const response = await axiosAuth.patch(`/fornecedor/${id}`, payload)
            setters.setIsLoading(false)
            toast.success('Fornecedor atualizado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao atualizar fornecedor')
        }
    }


    //#endregion

    //#region produto //Page, per_page, sort, sort_dir, filter

    const getProdutos = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/produto?${query}`)
            setters.setIsLoading(false)
            setters.setDataProdutos(response.data.data)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar produtos'
            console.error('getProdutos - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    const getNextCodigoNet = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/produto/codigonet/proximo`)
            setters.setIsLoading(false)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar produtos'
            console.error('getProdutos - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    const getProdutosHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/produto/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setProdutosHistorico(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            toast.error(err.response?.data?.msg || 'Erro ao buscar histórico de produtos')
        }
        return false
    }

    const getProdutosCadastro = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/produto/semarquivo/busca?${query}`)
            setters.setIsLoading(false)
            setters.setDataProdutos(response.data.data)
            return response.data.data;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar produtos'
            console.error('getProdutos - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    const getEstatisticasProdutos = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/produto')
            setters.setIsLoading(false)
            setters.setDataEstatisticaProdutos(response.data.data)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar estatísticas de produtos'
            console.error('getEstatisticasProdutos - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    const postProdutos = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/produto', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            setters.setIsLoading(false)
            toast.success('Produto criado com sucesso')
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao criar produto'
            console.error('postProdutos - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    const putProdutos = async (data, id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.patch(`/produto/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setters.setIsLoading(false)
            toast.success('Produto atualizado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao atualizar produto'
            console.error('putProdutos - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    const getProdutosCampos = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/produtos/campostdebusca`)
            setters.setIsLoading(false)
            return response.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar campos de produtos'
            console.error('getProdutosCampos - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    const getProdutosCamposByCampos = async (caracteristica_id, caracteristica_valor) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/produtos/buscaporcampos/${caracteristica_id}/${caracteristica_valor}`)
            setters.setIsLoading(false)
            setters.setDataProdutos(response.data.data)
            return response.data.data;
        }
        catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar campos de produtos'
            console.error('getProdutosCamposByCampos - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    //#endregion

    //#region movimentacao //Page, per_page, sort, sort_dir, filter

    const getMovimentacoes = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/movimentacao?${query}`)
            setters.setIsLoading(false)
            setters.setDataMovimentacoes(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar movimentações'
            console.error('getMovimentacoes - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
        }
        return false;
    }

    const getMovimentacao = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/movimentacao/produto?${query}`)
            setters.setIsLoading(false)
            setters.setDataMovimentacoes(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar movimentações'
            console.error('getMovimentacoes - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
        }
        return false;
    }

    const getMovimentacaoId = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/movimentacao/${id}`)
            setters.setIsLoading(false)
            setters.setMovimentacao(response.data.data)
            return response.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar movimentações'
            console.error('getMovimentacoes - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
        }
        return false;
    }

    const getEstatisticasMovimentacoes = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/movimentacao')
            setters.setIsLoading(false)
            setters.setDataEstatisticaMovimentacoes(response.data.data)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar estatísticas de movimentações'
            console.error('getEstatisticasMovimentacoes - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }

    }

    const createMovimentacao = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/movimentacao', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            setters.setIsLoading(false)
            return response.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return { status: false, msg: 'Faça login novamente' };
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao criar movimentação'
            toast.error(errorMsg)
            return false;
        }
    }

    const postMovimentacoes = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/movimentacao', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setters.setIsLoading(false)
            toast.success('Movimentação criada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
        }
        return false;
    }

    const putMovimentacoes = async (data, id) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/movimentacao/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setters.setIsLoading(false)
            toast.success('Movimentação atualizada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao atualizar movimentação'
            toast.error(errorMsg)
            return false;
        }
    }

    const cancelMovimentacoes = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.patch(`/movimentacao/cancelamento/${id}`)
            setters.setIsLoading(false)
            toast.success('Movimentação cancelada com sucesso')
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao cancelar movimentação'
            console.error('cancelMovimentacoes - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }

    const returnMovimentacoes = async (data, id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.patch(`/movimentacao/retorno/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            setters.setIsLoading(false)
            toast.success('Movimentação retornada com sucesso')
            return true;
        }
        catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao retornar movimentação'
            console.error('returnMovimentacoes - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
            return false;
        }
    }


    const getMovimentacoesProduto = async (query, id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/movimentacao/produto/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setDataMovimentacoes(response.data.data)
            return response.data.data;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar movimentações'
            console.error('getMovimentacoes - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
        }
        return false;
    }

    const getMovimentacoesEntidade = async (query, id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/movimentacao/cliente/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setDataMovimentacoes(response.data.data.movimentacoes || [])
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao buscar movimentações'
            console.error('getMovimentacoes - Mensagem de erro:', errorMsg)
            toast.error(errorMsg)
        }
        return false;
    }

    //#endregion

    //#region requests 

    const getRequestsDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/requests/metrics')
            setters.setIsLoading(false)
            setters.setDataEstatisticaRequests(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
        }
    }

    const getRequests = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/requests?${query}`)
            setters.setIsLoading(false)
            setters.setDataRequests(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao carregar requests')
            }
        }
    }



    //#endregion


    //#region campos personalizados
    // const [dataCamposPersonalizados, setDataCamposPersonalizados] = useState([])
    // const [CamposPersonalizados, setCamposPersonalizados] = useState({})
    // const [modalCamposPersonalizados, setModalCamposPersonalizados] = useState(false)
    // const [camposPersonalizadosHistorico, setCamposPersonalizadosHistorico] = useState([])


    const getCamposPersonalizados = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/caracteristicasProduto?${query}`)
            setters.setIsLoading(false)
            setters.setDataCamposPersonalizados(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
        }
        return false;
    }

    const postCamposPersonalizados = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/caracteristicasProduto', data)
            setters.setIsLoading(false)
            toast.success('Campo personalizado criado com sucesso')
            return true;
        }
        catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
        }
        return false;
    }

    const putCamposPersonalizados = async (data, id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.patch(`/caracteristicasProduto/${id}`, data)
            setters.setIsLoading(false)
            toast.success('Campo personalizado atualizado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const msg = err.response?.data?.msg || 'Erro ao atualizar campo personalizado'
            toast.error(msg)
            return false;
        }
    }

    const getCamposPersonalizadosHistorico = async (id, query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/caracteristicasProduto/${id}?${query}`)
            setters.setIsLoading(false)
            setters.setCamposPersonalizadosHistorico(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
        return false;
    }

    const exportarListaEmail = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/exportacao/email', data)
            setters.setIsLoading(false)
            toast.success(response.data.msg)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error('Faça login novamente')
                return;
            }
            const errorMsg = err.response?.data?.msg || 'Erro ao exportar lista'
            toast.error(errorMsg)
            return false;
        }
    }







    //#endregion






    return (
        <AuthContextApi.Provider
            value={{
                exportarListaEmail,
                putMovimentacoes,
                getProdutosCamposByCampos,
                getProdutosCampos,
                getCamposPersonalizadosHistorico,
                putCamposPersonalizados,
                postCamposPersonalizados,
                getCamposPersonalizados,
                getNextCodigoNet,
                getRequests,
                getRequestsDataSistema,
                getLocalizacoesProprietario,
                getProdutosHistorico,
                getEntidade,
                getFornecedoresHistorico,
                getFornecedores,
                getEstatisticasFornecedores,
                postFornecedores,
                putFornecedores,
                getMarcaHistorico,
                getEquipamentoFormatoHistorico,
                getEquipamentoHistorico,
                getDepartamentoHistorico,
                putDepartamentos,
                postDepartamentos,
                getDepartamentos,
                getLocalizacaoHistorico,
                putLocalizacoes,
                postLocalizacoes,
                getLocalizacoes,
                getEntidadeHistorico,
                getMovimentacoesEntidade,
                getMovimentacoesProduto,
                getMovimentacaoId,
                getMovimentacao,
                getProdutosCadastro,
                returnMovimentacoes,
                cancelMovimentacoes,
                postMovimentacoes,
                createMovimentacao,
                getEstatisticasMovimentacoes,
                getMovimentacoes,
                putProdutos,
                postProdutos,
                getProdutos,
                getEstatisticasProdutos,
                putMarcas,
                postMarcas,
                getMarcas,
                getEstatisticasMarcas,
                getEntidades,
                postEntidades,
                putEntidades,
                getEstatisticasEntidades,
                putEquipamentoFormato,
                postEquipamentoFormato,
                getEquipamentosformatos,
                putEquipamentos,
                postEquipamentos,
                getEquipamentos,
                getEstatisticasEquipamentos,
                deleteUsuarios,
                profileAutenticationEmail,
                profileChangeEmailConfirmCheckLink,
                profileChangeEmailConfirm,
                profileChangeEmail,
                profileChangeSenha,
                getDashBoardataSistema,
                getClientePainelDataSistema,
                getClienteById,
                putCliente,
                postCliente,
                getClientesDataSistema,
                getClientes,
                getClientesQuery,
                getClientesByCpfCnpj,
                getLogsDataSistema,
                getLogsMetricas,
                getLogs,
                getRequestsMetricas,
                blockUnlockUsuarios,
                putRoleUsuarios,
                postUsuarios,
                getUsuariosDataSistema,
                getUsuarios,
                getUsuariosQuery,
                getRecuperacaoDeSenhaDataSistema,
                getRecuperacaoSenha,
                getRecuperacaoSenhaQuery,
                deleteLocalizacoes,
                login,
                checkLogin,
                forgotPass,
                forgotChangePass,
                logout,
                deleteEntidades,
                deleteDepartamentos
            }}>
            {children}
        </AuthContextApi.Provider>
    )
}

export default AuthProvider;
